export default "__VITE_ASSET__DNp0MKCB__"